/**
 * Deep links into the Yahoo DSP UI.
 *
 * The launch result carries campaign ids and nothing else — Yahoo's API returns
 * no UI link — so the address has to be built here. The campaign view the
 * operator actually wants is the campaign's line list:
 *
 *   https://dsp.yahooinc.com/app/campaigns/886839/lines
 *
 * This matters more on Yahoo than elsewhere: there is no delete API for
 * campaigns or lines, so a partially-created campaign can only be dealt with by
 * hand, and the link is how anyone gets to it.
 */

export const YAHOO_DSP_BASE_URL = 'https://dsp.yahooinc.com';

/**
 * Build the URL for one Yahoo campaign's line list.
 *
 * @param {string|number} campaignId - Yahoo campaign (order) id
 * @returns {string|null} the deep link, or null when there is no usable id
 */
export function buildYahooCampaignUrl(campaignId) {
  // An empty segment would silently produce `/app/campaigns//lines`, which
  // loads a page that is not the campaign — worse than showing no link at all.
  if (campaignId === null || campaignId === undefined) return null;

  const id = String(campaignId).trim();
  if (!id) return null;

  return `${YAHOO_DSP_BASE_URL}/app/campaigns/${encodeURIComponent(id)}/lines`;
}

export default buildYahooCampaignUrl;
